import React from 'react';
import { Paper, Typography, Box, Chip, Grid } from '@mui/material';
import ScoreBox from './ScoreBox';

export default function PerformanceSection({ performance }) {
  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2, mt: 5 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Other Performance
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Scaled 1–10 across criteria
      </Typography>

      <Typography variant="subtitle2">Scale Legend</Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: { xs: 2, md: 5 },
          p: 2,
        }}
      >
        <Chip label="1-3 Below Performance" sx={{ color: '#0e0909', backgroundColor: '#eeece4' }} />
        <Chip label="4-6 Good Performance" sx={{ color: '#0e0909', backgroundColor: '#eeece4' }} />
        <Chip label="7-8 Very Good" sx={{ color: '#0e0909', backgroundColor: '#eeece4' }} />
        <Chip label="9-10 Excellent" sx={{ color: '#0e0909', backgroundColor: '#eeece4' }} />
      </Box>

      <Grid container spacing={2}>
        <ScoreBox label="Student Engagement" value={performance?.avg_student_engagement_rating} />
        <ScoreBox label="Punctuality" value={performance?.avg_punctuality_rating} />
        <ScoreBox label="Extracurricular Activities" value={performance?.avg_extra_curricular_activities_rating} />
        <ScoreBox label="Attendance" value={performance.avg_attendance_rating} />
      </Grid>
    </Paper>
  );
}
